// extracted by mini-css-extract-plugin
export default {"container":"NotesDetails_container__I+Bf2"};